(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dhw-setblock"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Custom element in plaats van een losse <script>: bij een wissel naar
      een ander kleurproduct ververst Horizon de hele <main>, en scripts in
      die nieuwe HTML draaien niet opnieuw. Een gedefinieerd element pakt de
      nieuwe HTML vanzelf op.
    */
    if (customElements.get('dhw-setblok')) return;

    class DhwSetblok extends HTMLElement {
      constructor() {
        super();
        this._busy = false;
        this._onChange = this._onChange.bind(this);
        this._onClick = this._onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this._onChange);
        this.addEventListener('click', this._onClick);
        this._render();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('click', this._onClick);
      }

      _rows() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-dhwset-row]'));
      }

      _picked() {
        return this._rows().filter(function (row) {
          var check = row.querySelector('[data-dhwset-pick]');
          return check && check.checked;
        });
      }

      _variantId(row) {
        var field = row.querySelector('[data-dhwset-variant]');
        return field && field.value ? Number(field.value) : null;
      }

      _onChange(event) {
        var target = event.target;
        // Een maat kiezen betekent: ik wil dit erbij.
        if (target.matches('select[data-dhwset-variant]') && target.value) {
          var check = target.closest('[data-dhwset-row]').querySelector('[data-dhwset-pick]');
          if (check) check.checked = true;
        }
        this._say('');
        this._render();
      }

      _render() {
        var button = this.querySelector('[data-dhwset-add]');
        if (button) button.disabled = this._busy || this._picked().length === 0;
      }

      _say(text, isError) {
        var message = this.querySelector('[data-dhwset-message]');
        if (!message) return;
        message.textContent = text || '';
        message.hidden = !text;
        message.classList.toggle('dhwset__message--error', !!isError);
      }

      _onClick(event) {
        if (event.target.closest('[data-dhwset-add]')) this._add();
      }

      _add() {
        if (this._busy) return;
        var self = this;
        var picked = this._picked();
        if (!picked.length) return;

        var items = [];
        for (var i = 0; i < picked.length; i++) {
          var id = this._variantId(picked[i]);
          if (!id) {
            this._say('Kies een maat voor ' + picked[i].dataset.title + '.', true);
            var select = picked[i].querySelector('select[data-dhwset-variant]');
            if (select) select.focus();
            return;
          }
          items.push({ id: id, quantity: 1 });
        }

        var button = this.querySelector('[data-dhwset-add]');
        var label = button.textContent;
        this._busy = true;
        button.disabled = true;
        button.textContent = 'Toevoegen…';
        this._say('');

        // Dezelfde secties meevragen als product-form.js, zodat de
        // winkelwagenlade meteen de nieuwe inhoud krijgt.
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });

        var routes = (window.Theme && Theme.routes) || {};

        fetch(routes.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (response.ok) return data;
              var reason = data.description || data.message || '';
              console.warn('[Setblok] /cart/add gaf', response.status, data);
              throw new Error(reason || 'status ' + response.status);
            });
          })
          .then(function (data) {
            // Het winkelwagenicoon leest itemCount als het nieuwe totaal,
            // dus het echte totaal ophalen in plaats van het aantal toegevoegd.
            return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
              .then(function (response) {
                return response.json();
              })
              .catch(function () {
                return null;
              })
              .then(function (cart) {
                return { data: data, cart: cart };
              });
          })
          .then(function (result) {
            self._rows().forEach(function (row) {
              var check = row.querySelector('[data-dhwset-pick]');
              if (check) check.checked = false;
            });
            self._busy = false;
            button.textContent = label;
            self._render();
            self._say('Toegevoegd aan je winkelwagen.');

            /* Horizon's events zijn gewone Event-objecten met detail erop
               gezet (geen CustomEvent); de lade luistert op 'cart:update'
               en schuift open bij auto-open. */
            var event = new Event('cart:update', { bubbles: true });
            event.detail = {
              resource: result.cart || {},
              sourceId: self.id,
              data: {
                source: 'dhw-setblok',
                itemCount: result.cart ? result.cart.item_count : items.length,
                sections: result.data.sections,
              },
            };
            document.dispatchEvent(event);
          })
          .catch(function (error) {
            self._busy = false;
            button.textContent = label;
            self._render();
            self._say('Toevoegen lukte niet: ' + error.message, true);
          });
      }
    }

    customElements.define('dhw-setblok', DhwSetblok);
  })();
  } catch(e) { console.error(e); }
})();

})();
